import { createClient } from '@supabase/supabase-js'

// Supabase configuration - can be overridden with environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://yqmlqctpakqxtwzrdofl.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlxbWxxY3RwYWtxeHR3enJkb2ZsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY5Nzg3NDEsImV4cCI6MjA3MjU1NDc0MX0.ut5jmneThodWDj5fSfqFdUD6OY3Kuaym4Kt1ug1NjHg'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Expose Supabase client globally for ChatFlows widget
if (typeof window !== 'undefined') {
  window.__SUPABASE_CLIENT__ = supabase
}  